const getId = (entities, name) => {
  let result;
  entities.map(entity => {
    if(entity.name) {
      if (entity.name === name) {
        result = entity.id;
      }
    } else {
      if (entity.nameLang.es === name) {
        result = entity.id;
      }
    }
  });
  return result;
};

export default getId;